


































import { Component, Prop, Vue } from 'vue-property-decorator'
import { User } from '@/api/model/user'
import { Branch } from '@/api/model/branch'

export interface PerSubjectTableData {
    [subjectId: string]: {
        subject: User|Branch,
        value: number,
    }
}

@Component
export default class PerSubjectTable extends Vue {
    @Prop({ required: true, default: () => [] }) readonly data!: PerSubjectTableData
    @Prop() readonly subject!: User|Branch
    @Prop() readonly subjectLabel!: string
    @Prop() readonly valueLabel!: string
    @Prop() readonly formatter!: (value: number, precision?: number) => string

    get subjectIds(): string [] {
        return Object.keys(this.data)
    }

    get sortedSubjectIds(): string[] {
        return this.subjectIds
            .sort((a, b) => {
                return this.data[b].value - this.data[a].value
            })
            .filter(subjectId => !this.subject || this.subject.id === subjectId)
    }

    get totals() {
        const total = {
            value: 0,
        }

        Object.keys(this.data).forEach(subjectId => {
            total.value += this.data[subjectId].value
        })

        return total
    }

    formatSubject(subject: User|Branch): string {
        return subject.name
    }

    formatValue(value: number): string {
        value = Number(value)

        return this.formatter ? this.formatter(value) : value.toString()
    }

    isCurrentUser(subject: User|Branch): boolean {
        if (subject instanceof User) {
            return this.$currentUser.id === subject.id
        }

        if (subject instanceof Branch) {
            return this.$currentUser.getAvailableBranches().some(branch => {
                return branch.id === subject.id
            })
        }

        return false
    }
}
